import gold from "@/gold.svg";

export default function GoldCoinIcon({ size = 32, ...props }) {
  const title = "gram altın";
  return <img src={gold} width={size} height={size} alt={title} title={title} {...props} />;
}